<template lang="pug">
div
	div(v-if="!filtered")
		v-img.mb-6.d-flex.align-center(:src="require('~/assets/images/trips_header.png')" :aspect-ratio="20/7" gradient="-180deg,rgba(183, 226, 255, .20) 0%,rgba(183, 226, 255,.32)")
			h1.text-h1.text-center.white--text.fill-height.font-weight-bold(style="text-shadow: 0px 1px 4px #000; font-size:85px") {{contentpage.name}}
		.text-center.mb-6
			ws-content(style="max-width: 755px; margin:auto" :markdown="contentpage.content.markdown")
	v-data-iterator.mb-6(:items="filteredTrips" hide-default-footer disable-pagination)
		template(#no-data)
			v-alert.my-6.d-block(type="warning" color="accent" text border="bottom")
				div Helaas hebben we geen trips gevonden met je filters
		template(#default="{items}")
			v-row
				v-col(cols="12" md="4" v-for="trip in items" :key="trip.id")
					trip-card(v-bind="trip")
	//- .text-center.mb-6
		h2.mb-2 nog een dummy
		p(style="max-width: 755px; margin:auto") {{$t('page.trips:intro')}}
	vue-plyr.mb-6(:options='{"controls":["play", "progress", "volume", "play-large", "airplay", "fullscreen", "pip", "mute"], "disableContextMenu": false}')
		div(data-plyr-provider="youtube" data-plyr-embed-id="q3jUy6RTiqQ")

</template>
<script>
import gql from 'graphql-tag';
import Content from '@dengl/common/components/content.vue';
import MetaFragment from '@/components/graphql/metaFragment.graphql';
import TripCard from '@/components/trips/card.vue';

const query = gql`
	query getTripIndexpage($path: String) {
		contentpage(path: $path) {
			id
			name
			slug
			content {
				...ContentDataFragment
			}
			...MetaFragment
		}
		trips {
			id
			name
			slug
			image: locationPhoto
			introduction
			bulletpoints
			tags
			province
			destination {
				id
				slug
				name
			}
		}
	}
	${MetaFragment}
	${Content.fragments}
`;

export default {
	name: 'TripIndex',
	nuxtI18n: {
		paths: {
			'nl-NL': '/wintersport-in-nederland',
			'nl-BE': '/wintersport-in-nederland'
		}
	},
	components: {
		TripCard
	},
	props: {
		filters: {
			type: Object,
			default() {
				return {
					provinces: [],
					types: [],
					tags: []
				};
			}
		}
	},
	asyncData({ app, route }) {
		return app.$graphClient
			.query({
				query,
				variables: {
					path: route.path
				},
				errorPolicy: 'all'
			})
			.then(({ data, errors }) => {
				if (!data.contentpage) {
					return app.httpError(404, null, 'trips-01', errors);
				}
				if (errors) {
					throw errors[0];
				}

				app.meta(data.contentpage.meta);
				app.ads({});
				app.breadcrumbs({
					[data.contentpage.name]: {
						name: 'trips'
					}
				});

				return data;
			})
			.catch(error => {
				return app.httpError(500, null, 'trips-02', error);
			});
	},
	head() {
		return {
			...this.$structuredData()
		};
	},
	computed: {
		filtered() {
			return (
				this.filters.provinces.length ||
				this.filters.types.length ||
				this.filters.tags.length
			);
		},
		filteredTrips() {
			if (!this.filtered) {
				return this.trips;
			}
			return this.trips.filter(trip => {
				return (
					(this.filters.provinces.length === 0 ||
						this.filters.provinces.includes(trip.province)) &&
					(this.filters.types.length === 0 ||
						this.filters.types.includes(
							trip.destination.__typename.toLowerCase()
						)) &&
					(this.filters.tags.length === 0 ||
						this.filters.tags.filter(value => trip.tags.includes(value)).length)
				);
			});
		}
	}
};
</script>
